












import { Component, Vue } from 'vue-property-decorator'
import Page from '@/components/Page/index.vue'
import FacetedSearch from '@/components/FacetedSearch/index.vue'

@Component({
  components: { Page, FacetedSearch },
})
export default class IndexedSearchResults extends Vue {
  get initialQuery(): string {
    return (this.$route.query.q as string) || ''
  }
}
